import React, { useEffect, useState } from "react";
import DayjsUtils from "@date-io/dayjs";
import { createTheme, ThemeProvider } from "@material-ui/core";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import dayjs from "dayjs";

import {
  dateByAdding,
  isNullOrUndefined,
  returnDates,
} from "../../HWLibrary/HWUtils";
import { s360ConfigService } from "../../Services/S360Config";

function MessageA5(props) {
  const [dateInputs, setDateInputs] = useState({});

  useEffect(() => {
    setDateInputs(parseDateInputs(props));
  }, [props])
  console.log(dateInputs, "special name")

  const [a5State, setA5State] = useState({
    dateInputs: dateInputs,
    selectedDate: dateInputs.minDate || new Date(),
    value: "",
    actionDone: false,
    maxDate: new Date(dateInputs.maxDate),
    minDate: new Date(dateInputs.minDate),
  });

  useEffect(() => {
    window.addEventListener(
      "message",
      (messageEvent) => {
        console.log(messageEvent, "A5MESSAGEEVENT");

        try {
          switch (messageEvent.data.event) {
            case "calendly.event_scheduled":
              onSubmitCalendly();
              break;
            case "calendly.date_and_time_selected":
              setA5State(prev => ({ ...prev, dateandTimeSelected: messageEvent.data }));
              break;

            default:
              break;
          }
        } catch (error) {
          console.log("Invalid Message Data: ");
        }
      },
      false
    );
  }, []);

  const onMouseEnterButton = (e) => {
    if (!e.target) {
      return;
    }
    if (e.target.disabled === true) {
      return;
    }
    // e.target.style.color = s360ConfigService?.config?.configDetails?.primaryFontColor;
    // e.target.style.backgroundColor = s360ConfigService?.config?.configDetails?.primaryColor;
  };

  const onMouseLeaveButton = (e) => {
    if (!e.target) {
      return;
    }
    // e.target.style.color = s360ConfigService?.config?.configDetails?.primaryColor;
    // e.target.style.backgroundColor = s360ConfigService?.config?.configDetails?.primaryColor;
  };

  const parseDateInputs = (props) => {
    let dateInputs = {};
    if (props.entry.text_data) {
      console.log(props.entry, "entry check");
      let data = props?.entry.text_data;
      if (
        !isNullOrUndefined(data.from_day) &&
        !isNullOrUndefined(data.to_day)
      ) {

        dateInputs.minDate = new Date(dateByAdding(data.from_day));


        dateInputs.maxDate = new Date(dateByAdding(parseInt(data.to_day)));

      } else {
        if (data.from_date) {
          dateInputs.minDate = returnDates(data.from_date);
        }
        if (data.to_date) {
          dateInputs.maxDate = returnDates(data.to_date);
        }

        let date = dateInputs.minDate;
        let datearray = date.split("/");
        let newdate = datearray[1] + "/" + datearray[0] + "/" + datearray[2];
        dateInputs.minDate = newdate;

        let date1 = dateInputs.maxDate;
        let datearray1 = date1.split("/");
        let newdate1 =
          datearray1[1] + "/" + datearray1[0] + "/" + datearray1[2];
        dateInputs.maxDate = newdate1;
      }
    }

    console.log(dateInputs, "dateInputs");
    return dateInputs;
  };

  const messageBoxStyle = () => {
    return s360ConfigService.config?.customDesign?.messageA5Box;
  };

  const messageBoxSubmitStyle = () => {
    return {
      marginBottom:"2rem",
      borderWidth: "1px",
      borderStyle: "solid",
      borderColor: s360ConfigService?.config?.configDetails?.primaryColor,
      borderRadius: 5,
      color: "#fff",
      backgroundColor: s360ConfigService?.config?.configDetails?.primaryColor,
      ...s360ConfigService.config?.customDesign?.messageA5Submit
    };
  };

  const onDateSelect = (selectedDate) => {
    setA5State(prev => ({ ...prev, selectedDate: selectedDate, value: selectedDate }));
    if (a5State.actionDone) {
      setA5State(prev => ({ ...prev, selectedDate: selectedDate, value: false }));
    } else {
      setA5State(prev => ({ ...prev, selectedDate: selectedDate, value: selectedDate }));
    }
  };

  const onSubmit = (e) => {
    console.log(
      dayjs(a5State.selectedDate).format("DD/MM/YY"),
      "data in a5"
    );
    onMouseLeaveButton(e);
    setA5State(prev => ({ ...prev, value: false, actionDone: true }));
    props.actions.sendMessage(
      dayjs(a5State.selectedDate).format("DD/MM/YYYY")
    );
    var n = document.getElementsByClassName(
      "s360-message-box-custom-a15-received"
    );
    for (var i = 0; i < n.length; i++) {
      n[i].disabled = true;
      n[i].style.background = "none";
      // onMouseLeave({ "target": n[i]});
    }
  };
  const onSubmitCalendly = () => {
    setA5State(prev => ({ ...prev, value: false, actionDone: true }));
    props.actions.sendMessage("Scheduled");
  };
  const materialTheme = createTheme({
    palette: {
      primary: {
        main: s360ConfigService?.config?.configDetails?.primaryColor,
        light: s360ConfigService?.config?.configDetails?.primaryColor,
        dark: s360ConfigService?.config?.configDetails?.primaryColor,
      },
      secondary: {
        main: s360ConfigService?.config?.configDetails?.primaryFontColor,
      },
    },
    overrides: {
      MuiPickersToolbar: {
        toolbar: {
          backgroundColor: isNullOrUndefined(
            s360ConfigService?.config?.configDetails?.primaryColor
          )
            ? "rgb(242, 101, 34)"
            : s360ConfigService?.config?.configDetails?.primaryColor
        },
      },

      MuiPickersDay: {
        day: {
          color: isNullOrUndefined(s360ConfigService?.config?.configDetails?.primaryColor)
            ? "rgb(242, 101, 34)"
            : props.config.calenderBackgroundColor,
        },
        daySelected: {
          backgroundColor: isNullOrUndefined(
            s360ConfigService?.config?.configDetails?.primaryColor
          )
            ? "rgb(242, 101, 34)"
            : s360ConfigService?.config?.configDetails?.primaryColor,
        },
        dayDisabled: {
          color: "#c3c7c4",
        },
        current: {
          color: "#c3c7c4",
        },
      },
      MuiPickersModal: {
        dialogAction: s360ConfigService.config?.customDesign?.messageA5MuiPickerDialogAction,
      },
    },
  });

  const displayText = props.entry.text;
  const disableSundays = (date) => {
    if (new Date(date).getDay() == 0) return true;
  }

  return (
    <>
      {
        <div className="s360-message-cotainer-received">
          <div
            className="s360-message-box-custom-a14-received"
            style={messageBoxStyle()}
          >
            {displayText && <div>{displayText}</div>}
            <div style={{ paddingTop: "10px" }}>
              <MuiPickersUtilsProvider locale="en" utils={DayjsUtils}>
                <ThemeProvider theme={materialTheme}>
                  <KeyboardDatePicker
                    allowKeyboardControl={false}
                    autoOk
                    {...a5State.dateInputs}
                    minDate={new Date(dateInputs.minDate)}
                    maxDate={new Date(dateInputs.maxDate)}
                    variant="inline"
                    label=""
                    format="DD/MM/YYYY"
                    value={a5State.selectedDate}
                    helperText=""
                    onChange={onDateSelect}
                    disablePast={true}
                    shouldDisableDate={
                      !isNullOrUndefined(props.config.enableWeekend)
                        ? ""
                        : disableSundays
                    }
                    selectedDate={a5State.selectedDate}
                  />
                </ThemeProvider>
              </MuiPickersUtilsProvider>
            </div>
          </div>
          {props.isLastEntry && props.sentTimestamp && (
            <div
            // className={messageTimeClassName()} // TODO: check function implementation
            // style={messageTimeStyle()} // TODO: check function implementation
            >
              {dayjs.unix(props.sentTimestamp).format("DD MMM h:mm a")}
            </div>
          )}
          <div className="s360-message-cotainer-received">
            <button
              disabled={props.disabled}
              className="s360-message-box-custom-a15-received"
              onClick={onSubmit}
              onMouseEnter={onMouseEnterButton}
              onMouseLeave={onMouseLeaveButton}
              style={messageBoxSubmitStyle()}
            >
              {props.entry.data
                ? JSON.parse(props.entry.data).buttonText
                : "Submit"}
            </button>
          </div>
        </div>
      }
    </>
  );
}

export default MessageA5;
